export default __webpack_public_path__ + "static/media/user.4b37a0fc.svg";